import React, { FunctionComponent } from 'react';

import { default as MuiTableRow, TableRowProps } from '@mui/material/TableRow';

const TableRow: FunctionComponent<TableRowProps> = (props: TableRowProps) => {
  return <MuiTableRow {...props}>{props.children}</MuiTableRow>;
};

export default TableRow;
